import Vue from 'vue'
import VueResource from 'vue-resource'
import store from '../store'

Vue.use(VueResource)

export default {
  checkingRoles (roles, permissions) {
    const redirects = {
      'guest': '/login',
      'client': '/login',
      'member': '/login',
      'admin': '/dashboard'
    }

    for (var i = 0; i < permissions.length; i++) {
      for (var j = 0; j < roles.length; j++) {
        if (permissions[i] === roles[j]) {
          return {admitted: true}
        }
      }
    }

    return { admitted: false, redirect: redirects[roles[0]] }
  },

  /**
   * Get data from local storage and put in to vuex
   *
   * @return {void}
   */
  fromStorageToStore () {
    let token = localStorage.getItem(store.state.auth.storage)
    if (token !== null) store.commit('SET_TOKEN', token)

    let refreshToken = localStorage.getItem(store.state.auth.refreshStorage)
    if (refreshToken !== null) store.commit('SET_REFRESH_TOKEN', refreshToken)

    let registrationToken = localStorage.getItem(store.state.auth.registrationStorage)
    if (registrationToken !== null) store.commit('SET_REGISTRATION_TOKEN', registrationToken)

    let registrationStep = localStorage.getItem(store.state.auth.registrationStorageStep)
    if (registrationStep !== null) store.commit('SET_REGISTRATION_STEP', registrationStep)
  },

  /**
   * Create interceptors for api requests, to add token to headers and logout if bad token,
   *
   * @return {void}
   */
  initInterceptors () {
    Vue.http.interceptors.push((request, next) => {
      let authToken = store.state.auth.token ? store.state.auth.token : store.state.auth.registrationToken
      let hasAuthHeader = request.headers.has('Authorization')
      if (authToken && !hasAuthHeader) {
        request.headers.set('Authorization', 'Bearer ' + authToken)
        hasAuthHeader = true
      }

      let hasContentType = request.headers.has('Content-Type')
      if (!hasContentType) {
        request.headers.set('Content-Type', 'application/json')
      }

      next((response) => {
        if (hasAuthHeader && this._isInvalidToken(response)) {
          if (authToken && store.state.auth.refreshToken) {
            store.dispatch('REFRESH_TOKEN').then(_ => {
              location.reload()
            }, _ => {
              store.dispatch('LOGOUT')
            })
          } else {
            store.dispatch('LOGOUT')
          }
        }
      })
    })
  },

  /**
   * Clear all auth data
   *
   * @return {void}
   */
  clearAllAuthData () {
    this.clearAuthTokens()
    this.clearRegistrationTokens()
  },

  /**
   * Clear auth tokens
   *
   * @return {void}
   */
  clearAuthTokens () {
    localStorage.removeItem(store.state.auth.storage)
    localStorage.removeItem(store.state.auth.refreshStorage)
    store.commit('CLEAR_AUTH')
    store.commit('CLEAR_USER')
  },

  /**
   * Clear registration tokens
   *
   * @return {void}
   */
  clearRegistrationTokens () {
    localStorage.removeItem(store.state.auth.registrationStorage)
    localStorage.removeItem(store.state.auth.registrationStorageStep)
    store.commit('CLEAR_REGISTRATION')
  },

  /**
   * Check if the Vue-resource Response is an invalid token response.
   *
   * @private
   * @param {Response} response The Vue-resource Response instance received from an http call.
   * @return {boolean}
   */
  _isInvalidToken (response) {
    const status = response.status
    const error = response.data.error

    return ((status === 401 || (error === 'invalid_token' || error === 'expired_token' || error === 'Unauthorized')) || (status === 400 && error === 'invalid_grant'))
  }
}



// WEBPACK FOOTER //
// ./src/services/auth.js